import React, { useEffect } from 'react';
import tw, { styled } from 'twin.macro';
import { SubmitHandler, useForm } from 'react-hook-form';
import { useSwiperSlide } from 'swiper/react';

import { Question } from '../../../entities/question';
import { strings } from '../../../localization/strings';
import QuestionnaireFooterButtons from '../footer-buttons';
import useTextAreaFocus from '../../../hooks/use-textarea-focus';

const DefaultTextarea = styled.textarea`
  ${tw`shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full mb-3 mt-1 border-content-500 rounded-md`}// max-width: 20rem;
`;

const Label = styled.label`
  ${tw`block text-sm font-medium text-content-700 font-bold pl-2`}
`;

interface ComponentProps {
  question: Question;
  onContinue?: (text: string) => void;
}

type Input = {
  text: string;
};

function QuestionnaireQuestionTextLongComponent({ question, onContinue }: ComponentProps) {
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm<Input>();

  const slide = useSwiperSlide();
  const [textareaRef, setInputFocus] = useTextAreaFocus();

  const onSubmit: SubmitHandler<Input> = async (data) => {
    if (onContinue) {
      onContinue(data.text);
    }
  };

  if (question.answerText) {
    setValue('text', question.answerText);
  }

  useEffect(() => {
    if (slide.isActive) {
      setTimeout(() => {
        setInputFocus();
      }, 500);
    }
  }, [slide, setInputFocus]);

  const { ref, ...questionInputProps } = register('text', { required: true });

  return (
    <form noValidate onSubmit={handleSubmit(onSubmit)}>
      {question.fieldName && <Label>{question.fieldName}</Label>}
      <DefaultTextarea
        rows={5}
        className={`${errors.text ? 'border-rose-700' : ''}`}
        {...questionInputProps}
        ref={(e) => {
          ref(e);
          textareaRef.current = e;
        }}
      />
      {errors.text && <span className="text-red-600">{strings().error.fieldIsRequired}</span>}

      <QuestionnaireFooterButtons onContinue={() => handleSubmit(onSubmit)} />
    </form>
  );
}

QuestionnaireQuestionTextLongComponent.defaultProps = {
  onContinue: () => null,
};

export default QuestionnaireQuestionTextLongComponent;
